import { NoIndex } from "@/common/components/no-index";
import getTranslations from "../../lib/getTranslations";

import { SimilarProducts } from "@/components/similar-products/SimilarProducts";

const SimilarProductsPage = () => {
  return (
    <>
      <NoIndex />
      <SimilarProducts />
    </>
  );
};

export const getStaticProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await getTranslations(locale, ["similar-products"])),
    },
  };
};

export default SimilarProductsPage;
